var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link' : 'a',_vm._b({tag:"component",staticClass:"btnCta",class:_vm.variant ? `btn--${_vm.variant}` : '',style:({ '--btn-color': _vm.resolvedColor, '--btn-hover-color': _vm.resolvedHoverColor })},'component',_vm.linkProps,false),[_c('span',{staticClass:"btnLabel"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }